import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false

/** vue-debounce */
import vueDebounce from 'vue-debounce'
Vue.use(vueDebounce)

/** axios */
import axiosPlugin from './plugins/axios'
Vue.use(axiosPlugin)

/** currency.js */
import currencyPlugin from './plugins/currency'
Vue.use(currencyPlugin)

/** Vue filters */
Vue.filter("ff", v => v.replace(".", ";").replace(",", ".").replace(";", ",").substring(0, v.length - 3))

;(async () => {
  try {
    const { data } = await Vue.prototype.$http.get("/auth/")
    localStorage.setItem("user", JSON.stringify(data))
  } catch {
    localStorage.setItem("user", null)
  }

  // Set user state here (after authentication above)
  store.state.user = JSON.parse(localStorage.getItem('user'))

  new Vue({
    store,
    router,
    vuetify,
    render: h => h(App),
    created() {
      // Get csrf token
      this.$http.get("/auth/csrf-cookie/")
    }
  }).$mount('#app')
})()
